import { ApiUrls } from '../ApiUrls';
import { httpService } from '../..';
import { ISalesComplianceFilters } from '../filters';
import { ISalesComplianceResponse } from './complianceSalesInterfaces';

export async function FetchSalesCompliance(filters: ISalesComplianceFilters): Promise<ISalesComplianceResponse> {
  try {
    const response = await httpService.get(ApiUrls.salesCompliance(filters));
    return await response.json();
  } catch (e) {
    throw e;
  }
}
